var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcFile = function SvgIcFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 6.09375H12.5353L11.0597 3.33469C10.8998 3.03512 10.6614 2.78467 10.3701 2.61012C10.0788 2.43557 9.74553 2.3435 9.40594 2.34375H3.28125C2.24719 2.34375 1.40625 3.18469 1.40625 4.21875V25.7812C1.40625 26.8153 2.24719 27.6562 3.28125 27.6562H26.7188C27.7528 27.6562 28.5938 26.8153 28.5938 25.7812V7.96875C28.5938 6.93469 27.7528 6.09375 26.7188 6.09375ZM3.28125 4.21875H9.40594L11.4113 7.96875H26.7188V10.8394C26.7066 10.8394 26.6953 10.8356 26.6831 10.8356H3.31781C3.30563 10.8356 3.29437 10.8394 3.28125 10.8394V4.21875ZM3.28125 25.7812V22.9688L3.31781 12.7106L26.7188 12.7463V22.9688H26.7206V25.7812H3.28125Z",
    fill: "#666666"
  })));
};
export default SvgIcFile;